module.exports = __webpack_public_path__ + "media/images/athletes/2851-45355db3bca60331aea243be26dfdf95.png";